module.exports = "https://static.wmbcdn.com/uniweb/images/cab2760165e8c6c248caad58a4b300bb.svg";